// extracted by mini-css-extract-plugin
module.exports = {"section":"_30fZh","serviceButtonContainer":"_10tuC","image":"_16cle"};